import React, { useEffect, useState } from "react";

import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  LinearProgress,
  CircularProgress,
  Alert,
  Container,
  Backdrop,
} from "@mui/material";
import { Star } from "@mui/icons-material";
import { useGetAllStoresRattingQuery } from "../../redux/Slices/rattingApi";
import MDBox from "components/MDBox";
import { DataGrid } from "@mui/x-data-grid";

// Rating Level Component
const RatingLevelChip = ({ level, score }) => {
  const getLevelConfig = (level) => {
    const configs = {
      excellent: { label: "ممتاز", color: "success" },
      good: { label: "جيد", color: "success" },
      average: { label: "متوسط", color: "warning" },
      poor: { label: "ضعيف", color: "error" },
    };
    return configs[level] || { label: level, color: "default" };
  };

  const config = getLevelConfig(level);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, height: "100%" }}>
      <Chip label={config.label} color={config.color} size="small" sx={{ fontWeight: "bold" }} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Star sx={{ color: "#ffa726", fontSize: 20 }} />
        <Typography variant="body2" fontWeight="bold">
          {score.toFixed(1)}
        </Typography>
      </Box>
    </Box>
  );
};

// Metric Card Component
const MetricCard = ({ icon, label, value, unit, color = "primary" }) => (
  <Card sx={{ height: "100%", bgcolor: `${color}.50` }}>
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        {icon}
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
      </Box>
      <Typography variant="h6" fontWeight="bold" color={`${color}.main`}>
        {value}
        {unit}
      </Typography>
    </CardContent>
  </Card>
);

const columns = [
  { field: "id", headerName: "معرف التقييم", flex: 1 },
  { field: "store", headerName: "اسم المتجر", flex: 1 },
  {
    field: "Ratting",
    headerName: "التقييم",
    flex: 1,
    renderCell: (params) => (
      <RatingLevelChip level={params.row.rating_level} score={params.row.score} />
    ),
  },
  {
    field: "overall_rank",
    headerName: "الترتيب العام",
    flex: 1,

    renderCell: (params) => (
      <Chip label={`${params.row.overall_rank}`} variant="outlined" color="primary" size="small" />
    ),
  },
  { field: "orders_completed", headerName: "الطلبات المكتملة", flex: 1 },
  {
    field: "delivery_time",
    headerName: "التسليم في الوقت",
    flex: 1,
    renderCell: (params) => (
      <Box sx={{ display: "flex", alignItems: "center", height: "100%", gap: 1 }}>
        <LinearProgress
          variant="determinate"
          value={params.row.on_time_delivery_rate}
          sx={{ width: 60, height: 6, borderRadius: 3 }}
          color={85 > params.row.on_time_delivery_rate > 70 ? "success" : "warning"}
        />
        <Typography variant="caption">{params.row.on_time_delivery_rate}%</Typography>
      </Box>
    ),
  },
  {
    field: "return_rate",
    headerName: "معدل الإرجاع",
    flex: 1,
    renderCell: (params) => (
      <Typography
        sx={{ display: "flex", height: "100%", alignItems: "center", gap: 1 }}
        variant="body2"
        color={params.row.return_rate < 3 ? "success.main" : "warning.main"}
      >
        {params.row.return_rate}%
      </Typography>
    ),
  },
];

// show stores ratting and reviews
const Ratting = () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const {
    data: storesRating,
    error,
    isLoading: loadingStoresRating,
  } = useGetAllStoresRattingQuery(page);

  const handlePageChange = (event, value) => {};

  if (loadingStoresRating) {
    return (
      <Backdrop>
        <CircularProgress />
      </Backdrop>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: 4 }}>
        <Alert severity="error">حدث خطأ: {error}</Alert>
      </Container>
    );
  }

  return (
    <MDBox pt={6} pb={3}>
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          mb={3}
          py={3}
          px={2}
          borderRadius="lg"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            boxShadow: 3,
          }}
        >
          <Typography variant="h4" fontWeight="bold" color="white" gutterBottom>
            تقييمات المتاجر
          </Typography>
        </MDBox>
        <Box dir="rtl" sx={{ p: 2 }} bgcolor={"transparent"}>
          <DataGrid
            rows={storesRating.data}
            columns={columns}
            pageSize={10}
            paginationMode="server"
            page={page}
            rowCount={storesRating?.total || 0}
            autoHeight
          />
        </Box>
      </Card>
    </MDBox>
  );
};

export default Ratting;
